// extracted by mini-css-extract-plugin
export default {"spinner__container":"Spinner_spinner__container__tn0gf","spinner":"Spinner_spinner__Z6H3Z","spin":"Spinner_spin__Q9zsz"};